var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListingViewImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D7D7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_8371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0476 15.454C23.4622 14.174 21.1669 10 16.1669 10C11.1669 10 8.87157 14.174 8.28624 15.454C8.20767 15.6255 8.16699 15.812 8.16699 16.0007C8.16699 16.1893 8.20767 16.3758 8.28624 16.5473C8.87157 17.826 11.1669 22 16.1669 22C21.1669 22 23.4622 17.826 24.0476 16.546C24.126 16.3747 24.1666 16.1884 24.1666 16C24.1666 15.8116 24.126 15.6253 24.0476 15.454ZM16.1669 20.6667C11.9622 20.6667 10.0002 17.0893 9.50024 16.0073C10.0002 14.9107 11.9622 11.3333 16.1669 11.3333C20.3616 11.3333 22.3242 14.8953 22.8336 16C22.3242 17.1047 20.3616 20.6667 16.1669 20.6667Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1668 12.667C15.5076 12.667 14.8631 12.8625 14.3149 13.2288C13.7668 13.595 13.3395 14.1156 13.0872 14.7247C12.8349 15.3338 12.7689 16.004 12.8975 16.6506C13.0262 17.2972 13.3436 17.8912 13.8098 18.3573C14.276 18.8235 14.8699 19.141 15.5165 19.2696C16.1631 19.3982 16.8334 19.3322 17.4424 19.0799C18.0515 18.8276 18.5721 18.4004 18.9384 17.8522C19.3047 17.3041 19.5002 16.6596 19.5002 16.0003C19.4991 15.1166 19.1476 14.2694 18.5227 13.6445C17.8978 13.0196 17.0506 12.6681 16.1668 12.667ZM16.1668 18.0003C15.7713 18.0003 15.3846 17.883 15.0557 17.6633C14.7268 17.4435 14.4704 17.1311 14.3191 16.7657C14.1677 16.4002 14.1281 15.9981 14.2053 15.6101C14.2824 15.2222 14.4729 14.8658 14.7526 14.5861C15.0323 14.3064 15.3887 14.1159 15.7767 14.0388C16.1646 13.9616 16.5667 14.0012 16.9322 14.1526C17.2977 14.3039 17.61 14.5603 17.8298 14.8892C18.0495 15.2181 18.1668 15.6048 18.1668 16.0003C18.1668 16.5308 17.9561 17.0395 17.581 17.4145C17.206 17.7896 16.6973 18.0003 16.1668 18.0003Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_8371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.16699 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingViewImage);
export default __webpack_public_path__ + "static/media/listing-view-image.3536ac596b3d3d734354d16eea7d95d5.svg";
export { ForwardRef as ReactComponent };